export const GRADE = {
  PETAHASH: 'Petahash',
  EXAHASH: 'Exahash',
  TERAHASH: 'Terahash',
  GIGAHASH: 'Gigahash',
  MEGAHASH: 'Megahash',
} as const;

type GradeType = (typeof GRADE)[keyof typeof GRADE];

type Props = {
  grade: GradeType;
  className?: string;
};

const GRADES: Record<GradeType, { background: string; text: string; label: string }> = {
  [GRADE.PETAHASH]: {
    background: 'bg-[#B899EB]/10',
    text: 'text-[#B899EB]',
    label: 'Petahash',
  },
  [GRADE.EXAHASH]: {
    background: 'bg-green-200/10',
    text: 'text-green-200',
    label: 'Exahash',
  },
  [GRADE.TERAHASH]: {
    background: 'bg-[#7DBBFF]/10',
    text: 'text-[#7DBBFF]',
    label: 'Terahash',
  },
  [GRADE.GIGAHASH]: {
    background: 'bg-[#FFCC00]/10',
    text: 'text-[#FFCC00]',
    label: 'Gigahash',
  },
  [GRADE.MEGAHASH]: {
    background: 'bg-[#9D00FF]/10',
    text: 'text-[#9D00FF]',
    label: 'Megahash',
  },
};

const GradeBadge = ({ grade, className }: Props) => {
  const badge = GRADES[grade];

  return (
    <div className={`rounded-full py-1 px-3 inline-block ${badge.background} ${className}`}>
      <span className={`text-xs font-normal whitespace-nowrap ${badge.text}`}>{badge.label}</span>
    </div>
  );
};

export default GradeBadge;
